import { ImplicitFlow, ThemeProvider } from '@vacasa/react-components-lib';
import defaultTheme from '@vacasa/react-components-lib/lib/themes/default';
import Container from '@mui/material/Container';
import { Router } from './Router';
import { Provider } from 'react-redux';
import { store } from './store';
import { Configuration } from './Configuration';
import './index.scss';
import { AuthRole } from './components/AuthRole/AuthRole';
import { useEffect, useState } from 'react';
import { getLocalUserContext, loadUserContext } from './contexts/userContext';
import OptimizelyService from './services/optimizelyService';
import { OptimizelyProvider } from '@optimizely/react-sdk';
import { LoadingProvider } from './contexts/LoadingContext';
import { nanoid } from '@reduxjs/toolkit';
import { LoadingOverlay } from './components/LoadingOverlay/LoadingOverlay';

const ALLOWED_DIRECTORY_HINTS = ['onelogin', 'authentik'];

export function App() {
    const getDirectoryHintFromUrl = (): string | undefined => {
        const hint = new URLSearchParams(window.location.search)?.get('directory_hint');
        return hint && ALLOWED_DIRECTORY_HINTS.includes(hint) ? hint : undefined;
    };

    const implicitFlowProps = Configuration.getIDPConfigurations(getDirectoryHintFromUrl());

    const AppContainer = () => {
        const userContext = getLocalUserContext();
        const [skip, setSkip] = useState<boolean>(false);
        const optimizely = OptimizelyService.getOptimizelyInstance();

        useEffect(() => {
            if (!skip) {
                loadUserContext();
                setSkip(true);
            }
        }, [userContext]);

        return (
            <>
                <OptimizelyProvider optimizely={optimizely as any} userId={nanoid()}>
                    <AuthRole userContext={userContext} />
                    <ThemeProvider theme={defaultTheme}>
                        <Container maxWidth={false} className="body-regular app-container">
                            <h1>Reviews Manager</h1>
                            <Router />
                        </Container>
                    </ThemeProvider>
                </OptimizelyProvider>
            </>
        );
    };

    return (
        <ImplicitFlow {...implicitFlowProps}>
            <Provider store={store}>
                <LoadingProvider>
                    <LoadingOverlay />
                    <AppContainer />
                </LoadingProvider>
            </Provider>
        </ImplicitFlow>
    );
}
